import { render, staticRenderFns } from "./MyProfileCollection.vue?vue&type=template&id=5c7fbe59&scoped=true"
import script from "./MyProfileCollection.vue?vue&type=script&lang=js"
export * from "./MyProfileCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7fbe59",
  null
  
)

export default component.exports